const CONFIG = {
  NEWS_API_URL: 'https://api-berita-indonesia.vercel.app/suara/',
};

export default CONFIG;
